module.exports = __webpack_public_path__ + "img/cyber-car01.86053a1f.jpg";